// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox_wrapper__FYn6H","inner":"checkbox_inner__nOOax","checkbox":"checkbox_checkbox__5jV4Q","label":"checkbox_label__pC6B0","dark":"checkbox_dark__d7p9Q"};